import React from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'

// components
import ImageWithFoster from 'components/ImageWithFoster'

// resources
import PreviewImage from 'assets/images/studio-preview-image-user.png'

// styles
import styles from './index.module.scss'

const CollectionSpotCard = ({ data }) => {
  const router = useRouter()

  // Extract banner image, profile picture, store name, description, and products
  const storeImage = data?.creatorStoreUrl?.length > 0 ? data.creatorStoreUrl : PreviewImage.src
  const username = data?.creatorUsername || data?.username || '@username'
  const storeName = data?.storeName || data?.name || 'Store Name'

  return (
    <div className={`${styles.borderContainer} dark:bg-[transparent]`}>
      <div className={styles.container}>
        <div className="relative flex-1 h-full py-[36px] px-[45px]">
          <div className="w-full flex gap-[36px]">
            <div className={styles.userImage}>
              <ImageWithFoster src={storeImage} className="w-full h-full rounded-[50px] overflow-hidden" />
            </div>
            <div>
              <div className={styles.userName}>{username}</div>
              <div className={styles.collectionName}>{storeName.toUpperCase()}</div>
            </div>
          </div>
          <div className="mt-[30px]">
            <div className={styles.title}>Description</div>
            <div className={styles.description}>{data?.description}</div>
          </div>
          <Link href={data?.targetUrl} passHref>
            <a>
              <div className={styles.viewCollection}>View Collection</div>
            </a>
          </Link>
        </div>
        <div className={styles.imageStack}>
          <div className={`${styles.imageLayer1} w-[327px] h-[428px] rounded-[8px] overflow-hidden`}>
            <ImageWithFoster src={data.items[0].itemUrl} className="w-full h-full object-cover" />
          </div>
          {data.items.length > 1 && (
            <div className={`${styles.imageLayer2} w-[290px] h-[380px] rounded-[8px] overflow-hidden`}>
              <ImageWithFoster src={data.items[1].itemUrl} className={`w-full h-full object-cover`} />
            </div>
          )}
          {data.items.length > 2 && (
            <div className={`${styles.imageLayer3} w-[259px] h-[342px] rounded-[8px] overflow-hidden`}>
              <ImageWithFoster src={data.items[2].itemUrl} className={`w-full h-full object-cover`} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CollectionSpotCard
